import { render, staticRenderFns } from "./schoolGoodsStudent.vue?vue&type=template&id=fc6d13ae"
import script from "./schoolGoodsStudent.vue?vue&type=script&lang=js"
export * from "./schoolGoodsStudent.vue?vue&type=script&lang=js"
import style0 from "./schoolGoodsStudent.vue?vue&type=style&index=0&id=fc6d13ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports